import React from 'react';

const LoadingSkeleton = ({ count = 3, height = 'h-24', className = '' }) => {
    return (
        <div className={`space-y-4 ${className} animate-pulse`}>
            {[...Array(count)].map((_, i) => (
                <div key={i} className={`bg-gray-200 rounded-lg ${height} w-full`} />
            ))}
        </div>
    );
};

export default LoadingSkeleton;
